import { render, staticRenderFns } from "./captura_mascotas.vue?vue&type=template&id=50d5fdb7&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./captura_mascotas.vue?vue&type=script&lang=js&"
export * from "./captura_mascotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports